{
  "version": 1,
  "asset_id": "6ce37b89-e4da-49c8-8bbe-6a02d6cb3ff1",
  "project_id": "4e628cc3-9baa-4a87-b23b-02ac04e85c33",
  "url": "/__l5e/assets-v1/6ce37b89-e4da-49c8-8bbe-6a02d6cb3ff1/resultado_4.png",
  "r2_key": "a/v1/4e628cc3-9baa-4a87-b23b-02ac04e85c33/6ce37b89-e4da-49c8-8bbe-6a02d6cb3ff1/resultado_4.png",
  "original_filename": "resultado_4.png",
  "size": 1001262,
  "content_type": "image/png",
  "created_at": "2026-07-07T11:53:14Z"
}
